"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { TableToolBarConstants } from "Constants/Table/TableToolBarConstants";
import { loadButtonsData, tbDeleteRowsClicked, tbEditBtnClicked } from "Actions/Table/TableToolBarActions";
import { d5TableExport, d5TableRefresh } from "Actions/Table/D5TableActions";
import { Fields, System } from 'Constants/objects';
import { FormEditConstants } from "Constants/Forms/FormEditConstants";
import { loadTableContextMenuData } from "Actions/Forms/FormEditTableActions";
import { sharedData } from 'SharedData';
import React from 'react';
import { AddButton, ClearQuickFiltersButton, DeleteButton, DeselectAllButton, EditButton, ExportToXlsButton, GotoButton, GotoButtonItemProp, PreferencesButton, RefreshButton, ReportsButton, ReportsButtonItemProp, SelectAllButton, ShowHeaderRowFilterButton, ShowModalFilterButton } from "D5Utils/toolbar_buttons";
import { Messages } from "Messages";
import { loadButtons as _loadButtons } from "D5Utils/common_requests";
import { SUBSYSTEM_STR } from 'Router';

var TableToolBarStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(TableToolBarStoreClass, _StoreClass);

  //crutch
  function TableToolBarStoreClass(instance, uuid, formOperation, formType, viewMode, parentUUID, isReadOnly) {
    var _this;

    _classCallCheck(this, TableToolBarStoreClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableToolBarStoreClass).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_UUID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tableInstance", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_dataFormButtons", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_dataContextMenu", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_tableTitle", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formTableMode", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_currentRowKey", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_objectName", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_formType", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_viewMode", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_toolbarItemsData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_buttonsForUpdateData", []);

    _this._toolbarInstance = instance;
    _this._UUID = uuid;
    _this._formTableMode = formOperation;
    _this._formType = formType;
    _this._viewMode = viewMode;
    _this._parentUUID = parentUUID;
    _this._isReadOnly = isReadOnly;
    _this.dispatcherToken = AppDispatcher.register(function (action) {
      switch (action.actionType) {
        case TableToolBarConstants.TOOLBAR_TABLE_FORM_LOAD_BUTTONS_DATA:
          _this._dataFormButtons = _objectSpread({}, action.dataFormButtons);
          _this._dataContextMenu = _objectSpread({}, action.dataContextMenu);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_FORM_TABLE_BUTTONS_DISABLING:
          if (action.formUUID === _this._UUID) _this.disableButtons(action);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_SET_DEFAULT_STATE:
          if (action.formUUID === _this._UUID) _this.setDefaultStateButtons();
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_FORM_SET_TITLE:
          _this._tableTitle = action.title;
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_FORM_SET_TABLE_ELEM:
          if (_this._UUID === action.formUUID) _this._tableInstance = action.tableInstance;
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_FORM_SET_ROW_KEY:
          if (_this._UUID === action.formUUID) _this._currentRowKey = action.currentRowKey;
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_SET_OBJECT_NAME:
          if (_this._UUID === action.formUUID) _this._objectName = action.objectName;
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_KEY_EVENT:
          if (_this._UUID === action.formUUID) _this.callTableKeyboardEvents(action.event);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_UPDATE_FORM_UUID:
          if (action.formUUID !== _this._UUID) {
            _this._UUID = action.nextFormUUID;

            _this.updateButtonsUUID();
          }

          break;

        case TableToolBarConstants.TOOLBAR_TABLE_TOGGLE_ATTRS:
          if (action.formUUID === _this._UUID) _this.toggleClasses(action);
          break;

        case TableToolBarConstants.TOOLBAR_TABLE_READONLY:
          if (action.formUUID === _this._parentUUID) _this.setReadOnlyMode(action);
          break;

        default:
          return true;
      }
    });
    return _this;
  }

  _createClass(TableToolBarStoreClass, [{
    key: "unregister",
    value: function unregister() {
      AppDispatcher.unregister(this.dispatcherToken);
    }
  }, {
    key: "getList",
    value: function getList() {//return Map(_store).toObject();
    }
  }, {
    key: "loadButtons",
    value: function loadButtons(formID) {
      var _this2 = this;

      this._formID = formID;

      _loadButtons({
        formID: formID,
        sorts: [Fields.Order]
      }).then(function (buttonsData) {
        _this2.buttonsData = buttonsData;

        _this2.createListData();

        loadButtonsData(_this2.itemsButtonsData, _this2.itemsContextMenu);
        loadTableContextMenuData(_this2.itemsContextMenu, _this2._UUID);

        _this2._toolbarInstance.dxToolbar({
          items: _this2.itemsButtonsData
        });

        if (_this2._isReadOnly) _this2.setReadOnlyMode();
        _this2._toolbarItemsData = _this2._toolbarInstance.dxToolbar('option', 'items');
      });
    }
  }, {
    key: "getButtonUrl",
    value: function getButtonUrl(buttonType, actionFormID) {
      var selKeys;
      var operation = buttonType === System.BUTTON_TYPE.ADD ? 'add' : buttonType === System.BUTTON_TYPE.EDIT ? 'edit' : null;
      var parentRoute = location.hash.slice(1);
      if (parentRoute[parentRoute.length - 1] === '/') parentRoute = parentRoute.slice(0, -1);

      if (this._tableInstance) {
        if (this._tableInstance.data('dxDataGrid')) {
          selKeys = this._tableInstance.dxDataGrid('getSelectedRowKeys')[0];
        } else if (this._tableInstance.data('dxTreeList')) {
          selKeys = this._tableInstance.dxTreeList('getSelectedRowKeys', 'all')[0];
        }
      }

      if (this._currentRowKey) {
        selKeys = this._currentRowKey;
      }

      switch (buttonType) {
        case System.BUTTON_TYPE.ADD:
          return "#".concat(parentRoute, "/").concat(operation, "/").concat(actionFormID, "/");

        case System.BUTTON_TYPE.EDIT:
          if (selKeys) return "#".concat(parentRoute, "/").concat(operation, "/").concat(actionFormID, "/").concat(selKeys);
      }
    }
  }, {
    key: "getPreferencesButton",
    value: function getPreferencesButton() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : System.BUTTON_POSITION.TOOLBAR;
      var preferencesButton = PreferencesButton.create({
        formUUID: this._UUID,
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU
      });

      this._buttonsForUpdateData.push(preferencesButton);

      return preferencesButton;
    }
  }, {
    key: "getSelectAllButton",
    value: function getSelectAllButton(type) {
      var selectAllButton = SelectAllButton.create({
        formUUID: this._UUID,
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU,
        beginGroup: true
      });

      this._buttonsForUpdateData.push(selectAllButton);

      return selectAllButton;
    }
  }, {
    key: "getDeselectAllButton",
    value: function getDeselectAllButton(type) {
      var deselectAllButton = DeselectAllButton.create({
        formUUID: this._UUID,
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU
      });

      this._buttonsForUpdateData.push(deselectAllButton);

      return deselectAllButton;
    }
  }, {
    key: "getShowFilterRowButton",
    value: function getShowFilterRowButton(type) {
      var showHeaderRowFilterButton = ShowHeaderRowFilterButton.create({
        formID: this._formID,
        formUUID: this._UUID,
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU
      });

      this._buttonsForUpdateData.push(showHeaderRowFilterButton);

      return showHeaderRowFilterButton;
    }
  }, {
    key: "getClearQuickFiltersButton",
    value: function getClearQuickFiltersButton(type) {
      var clearQuickFiltersButton = ClearQuickFiltersButton.create({
        formID: this._formID,
        formUUID: this._UUID,
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU
      });

      this._buttonsForUpdateData.push(clearQuickFiltersButton);

      return clearQuickFiltersButton;
    }
  }, {
    key: "getExportToXlsButton",
    value: function getExportToXlsButton(type) {
      var _this3 = this;

      var button = ExportToXlsButton.create({
        formID: this._formID,
        formUUID: this._UUID,
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU,
        items: [{
          text: Messages.Controls.ExportAll,
          icon: 'exportxlsx',
          onClick: function onClick() {
            return d5TableExport(_this3._UUID, false);
          }
        }, {
          text: Messages.Controls.ExportSelected,
          icon: 'exportselected',
          onClick: function onClick() {
            return d5TableExport(_this3._UUID, true);
          }
        }]
      });

      this._buttonsForUpdateData.push(button);

      return button;
    }
  }, {
    key: "getAddButton",
    value: function getAddButton(type, item) {
      var _this4 = this,
          _AddButton$create;

      return AddButton.create((_AddButton$create = {}, _defineProperty(_AddButton$create, Fields.ButtonType, item[Fields.ButtonType]), _defineProperty(_AddButton$create, Fields.ActionFormID, item[Fields.ActionFormID]), _defineProperty(_AddButton$create, "iconType", item[Fields.Icon]), _defineProperty(_AddButton$create, "isContextMenu", type === System.BUTTON_POSITION.CONTEXT_MENU), _defineProperty(_AddButton$create, "title", item[Fields.Title]), _defineProperty(_AddButton$create, "url", this.getButtonUrl(item[Fields.ButtonType], item[Fields.ActionFormID])), _defineProperty(_AddButton$create, "titleType", item[Fields.TitleType]), _defineProperty(_AddButton$create, "onMouseDown", function onMouseDown(e) {
        _this4.editButtonEvent(item, e);
      }), _AddButton$create));
    }
  }, {
    key: "getEditButton",
    value: function getEditButton(type, item) {
      var _this5 = this,
          _EditButton$create;

      return EditButton.create((_EditButton$create = {}, _defineProperty(_EditButton$create, Fields.ButtonType, item[Fields.ButtonType]), _defineProperty(_EditButton$create, Fields.ActionFormID, item[Fields.ActionFormID]), _defineProperty(_EditButton$create, "isContextMenu", type === System.BUTTON_POSITION.CONTEXT_MENU), _defineProperty(_EditButton$create, "type", item[Fields.ActionFormID_Type]), _defineProperty(_EditButton$create, "iconType", item[Fields.Icon]), _defineProperty(_EditButton$create, "title", item[Fields.Title]), _defineProperty(_EditButton$create, "url", this.getButtonUrl(item[Fields.ButtonType], item[Fields.ActionFormID])), _defineProperty(_EditButton$create, "titleType", item[Fields.TitleType]), _defineProperty(_EditButton$create, "onMouseDown", function onMouseDown(e) {
        _this5.editButtonEvent(item, e);
      }), _EditButton$create));
    }
  }, {
    key: "getDeleteButton",
    value: function getDeleteButton(type, item) {
      var _DeleteButton$create;

      var deleteButton = DeleteButton.create((_DeleteButton$create = {}, _defineProperty(_DeleteButton$create, Fields.ButtonType, item[Fields.ButtonType]), _defineProperty(_DeleteButton$create, Fields.ActionFormID, item[Fields.ActionFormID]), _defineProperty(_DeleteButton$create, "formUUID", this._UUID), _defineProperty(_DeleteButton$create, "iconType", item[Fields.Icon]), _defineProperty(_DeleteButton$create, "title", item[Fields.Title]), _defineProperty(_DeleteButton$create, "isContextMenu", type === System.BUTTON_POSITION.CONTEXT_MENU), _defineProperty(_DeleteButton$create, "titleType", item[Fields.TitleType]), _DeleteButton$create));

      this._buttonsForUpdateData.push(deleteButton);

      return deleteButton;
    }
  }, {
    key: "getRefreshButton",
    value: function getRefreshButton(type, item) {
      var _RefreshButton$create;

      var refreshButton = RefreshButton.create((_RefreshButton$create = {}, _defineProperty(_RefreshButton$create, Fields.ButtonType, item[Fields.ButtonType]), _defineProperty(_RefreshButton$create, Fields.ActionFormID, item[Fields.ActionFormID]), _defineProperty(_RefreshButton$create, "formUUID", this._UUID), _defineProperty(_RefreshButton$create, "iconType", item[Fields.Icon]), _defineProperty(_RefreshButton$create, "title", item[Fields.Title]), _defineProperty(_RefreshButton$create, "isContextMenu", type === System.BUTTON_POSITION.CONTEXT_MENU), _defineProperty(_RefreshButton$create, "titleType", item[Fields.TitleType]), _RefreshButton$create));

      this._buttonsForUpdateData.push(refreshButton);

      return refreshButton;
    }
  }, {
    key: "getShowModalFilterButton",
    value: function getShowModalFilterButton(type, item) {
      var showModalFilterButton = ShowModalFilterButton.create({
        formUUID: this._UUID,
        iconType: item[Fields.Icon],
        title: item[Fields.Title],
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU,
        titleType: item[Fields.TitleType]
      });

      this._buttonsForUpdateData.push(showModalFilterButton);

      return showModalFilterButton;
    }
  }, {
    key: "prepareGoToButton",
    value: function prepareGoToButton() {
      var _this6 = this;

      var gotoItems = this.buttonsData.filter(function (item) {
        return item[Fields.ButtonType] === System.BUTTON_TYPE.GOTO;
      });
      if (!gotoItems.length) return this.buttonsData;
      var toolBarData = this.buttonsData.filter(function (item) {
        return item[Fields.ButtonType] !== System.BUTTON_TYPE.GOTO;
      });
      var firstGotoElement = gotoItems[0];
      var gotoElement = {};
      gotoElement['items'] = gotoItems.map(function (item) {
        var gotoButtonItem = GotoButtonItemProp.create({
          title: item[Fields.Title],
          iconType: item[Fields.Icon],
          url: SUBSYSTEM_STR + item[Fields.ActionFormID],
          ActionFormID: item[Fields.ActionFormID],
          CustomParameters: item[Fields.CustomParameters],
          formUUID: _this6._UUID
        });

        _this6._buttonsForUpdateData.push(gotoButtonItem);

        return gotoButtonItem;
      }); //если приходит несколько кнопок с типом 6, то берем настройки из первой в списке

      gotoElement[Fields.Position] = firstGotoElement[Fields.Position];
      gotoElement[Fields.Order] = firstGotoElement[Fields.Order];
      gotoElement[Fields.ButtonType] = firstGotoElement[Fields.ButtonType];
      gotoElement[Fields.Title] = firstGotoElement[Fields.Title];
      toolBarData.push(gotoElement);
      return toolBarData;
    }
  }, {
    key: "getGoToButton",
    value: function getGoToButton(type, item) {
      var gotoButton = GotoButton.create({
        items: item['items'],
        title: item[Fields.Title],
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU,
        iconType: item[Fields.Icon],
        formUUID: this._UUID,
        titleType: item[Fields.TitleType]
      });

      this._buttonsForUpdateData.push(gotoButton);

      return gotoButton;
    }
  }, {
    key: "prepareReportsButton",
    value: function prepareReportsButton() {
      var _this7 = this;

      var reportsItems = this.buttonsData.filter(function (item) {
        return item[Fields.ButtonType] === System.BUTTON_TYPE.REPORT;
      });
      if (!reportsItems.length) return this.buttonsData;
      var toolBarData = this.buttonsData.filter(function (item) {
        return item[Fields.ButtonType] !== System.BUTTON_TYPE.REPORT;
      });
      var firstReportElement = reportsItems[0];
      var reportElement = {};
      reportElement['items'] = reportsItems.map(function (item) {
        var gotoButtonItem = ReportsButtonItemProp.create({
          title: item[Fields.Title],
          iconType: item[Fields.Icon],
          CustomParameters: item[Fields.CustomParameters],
          ActionFormID: item[Fields.ActionFormID],
          formUUID: _this7._UUID
        });

        _this7._buttonsForUpdateData.push(gotoButtonItem);

        return gotoButtonItem;
      }); //если приходит несколько кнопок с типом 7, то берем настройки из первой в списке

      reportElement[Fields.Position] = firstReportElement[Fields.Position];
      reportElement[Fields.Order] = firstReportElement[Fields.Order];
      reportElement[Fields.ButtonType] = firstReportElement[Fields.ButtonType];
      reportElement[Fields.Title] = firstReportElement[Fields.Title];
      toolBarData.push(reportElement);
      return toolBarData;
    }
  }, {
    key: "getReportsButton",
    value: function getReportsButton(type, item) {
      var reportsButton = ReportsButton.create({
        items: item['items'],
        title: item[Fields.Title],
        isContextMenu: type === System.BUTTON_POSITION.CONTEXT_MENU,
        titleType: item[Fields.TitleType]
      });

      this._buttonsForUpdateData.push(reportsButton);

      return reportsButton;
    }
  }, {
    key: "buttonsFactory",
    value: function buttonsFactory(type, item) {
      switch (item[Fields.ButtonType]) {
        case System.BUTTON_TYPE.ADD:
          return this.getAddButton(type, item);

        case System.BUTTON_TYPE.EDIT:
          return this.getEditButton(type, item);

        case System.BUTTON_TYPE.DELETE:
          return this.getDeleteButton(type, item);

        case System.BUTTON_TYPE.REFRESH:
          return this.getRefreshButton(type, item);

        case System.BUTTON_TYPE.FILTER:
          return this.getShowModalFilterButton(type, item);

        case System.BUTTON_TYPE.GOTO:
          return this.getGoToButton(type, item);

        case System.BUTTON_TYPE.REPORT:
          return this.getReportsButton(type, item);
      }
    }
  }, {
    key: "createListData",
    value: function createListData() {
      var _this8 = this;

      var itemsFormButtons = [];
      var itemsContextMenu = [];

      var setItemFormButtons = function setItemFormButtons(item) {
        var type = System.BUTTON_POSITION.TOOLBAR;

        var btn = _this8.buttonsFactory(type, item);

        if (btn) itemsFormButtons.push(btn);
      };

      var setItemContextMenu = function setItemContextMenu(item) {
        var type = System.BUTTON_POSITION.CONTEXT_MENU;

        var btn = _this8.buttonsFactory(type, item);

        if (btn) itemsContextMenu.push(btn);
      };

      this.buttonsData = this.prepareGoToButton();
      this.buttonsData = this.prepareReportsButton();

      _.each(this.buttonsData, function (item) {
        if (item[Fields.ButtonType] !== System.BUTTON_TYPE.CUSTOM) {
          if (_this8._formType === System.FORM_TYPE.TREE && item[Fields.ButtonType] === System.BUTTON_TYPE.FILTER) //пока что в дереве фильтры не работают нужно спрятать
            return;

          switch (item[Fields.Position]) {
            case System.BUTTON_POSITION.TOOLBAR:
              setItemFormButtons(item);
              break;

            case System.BUTTON_POSITION.CONTEXT_MENU:
              setItemContextMenu(item);
              break;

            case System.BUTTON_POSITION.ALL:
              setItemFormButtons(item);
              setItemContextMenu(item);
              break;
          }
        }
      });

      if (this._formType === System.FORM_TYPE.LIST) {
        itemsFormButtons.push(this.getSelectAllButton(System.BUTTON_POSITION.TOOLBAR), this.getDeselectAllButton(System.BUTTON_POSITION.TOOLBAR), this.getShowFilterRowButton(System.BUTTON_POSITION.TOOLBAR), this.getClearQuickFiltersButton(System.BUTTON_POSITION.TOOLBAR), this.getExportToXlsButton(System.BUTTON_POSITION.TOOLBAR), this.getPreferencesButton());
        itemsContextMenu.push(this.getSelectAllButton(System.BUTTON_POSITION.CONTEXT_MENU), this.getDeselectAllButton(System.BUTTON_POSITION.CONTEXT_MENU), this.getShowFilterRowButton(System.BUTTON_POSITION.CONTEXT_MENU), this.getClearQuickFiltersButton(System.BUTTON_POSITION.CONTEXT_MENU), this.getExportToXlsButton(System.BUTTON_POSITION.CONTEXT_MENU));
      } else if (this._formType === System.FORM_TYPE.TREE) {
        itemsFormButtons.push(this.getSelectAllButton(System.BUTTON_POSITION.TOOLBAR), this.getDeselectAllButton(System.BUTTON_POSITION.TOOLBAR), this.getPreferencesButton());
        itemsContextMenu.push(this.getSelectAllButton(System.BUTTON_POSITION.CONTEXT_MENU), this.getDeselectAllButton(System.BUTTON_POSITION.CONTEXT_MENU));
      }

      this.itemsButtonsData = itemsFormButtons;
      this.itemsContextMenu = itemsContextMenu;
    }
  }, {
    key: "editButtonEvent",
    value: function editButtonEvent(item, e) {
      var _this9 = this;

      var actionFormID = item[Fields.ActionFormID];
      var _System$BUTTON_TYPE = System.BUTTON_TYPE,
          EDIT = _System$BUTTON_TYPE.EDIT,
          MULTI_EDIT = _System$BUTTON_TYPE.MULTI_EDIT;
      var _System$FORM_EDIT_CRE = System.FORM_EDIT_CREATE_MODE,
          CM_ADD = _System$FORM_EDIT_CRE.ADD,
          CM_MULTI_EDIT = _System$FORM_EDIT_CRE.MULTI_EDIT,
          CM_EDIT = _System$FORM_EDIT_CRE.EDIT;
      if (sharedData.formEditProcessed) return;
      sharedData.formEditProcessed = true;
      var operation = CM_ADD;

      if (item[Fields.ButtonType] === EDIT) {
        operation = CM_EDIT;

        if (item[Fields.ActionFormID_Type] === MULTI_EDIT) {
          operation = CM_MULTI_EDIT;
        }
      }

      setTimeout(function () {
        tbEditBtnClicked({
          UUID: _this9._UUID,
          formID: actionFormID,
          mode: operation,
          byUrl: _this9._viewMode === System.FORM_TYPE.LIST,
          event: e
        });
      });
    }
  }, {
    key: "disableButtons",
    value: function disableButtons(_ref) {
      var _this10 = this;

      var buttons = _ref.buttons,
          disabled = _ref.disabled;
      var readOnlyButtons = [System.TOOLBAR_BTN_CLASSES.DEL, System.TOOLBAR_BTN_CLASSES.SELECT, System.TOOLBAR_BTN_CLASSES.DESELECT, System.TOOLBAR_BTN_CLASSES.GOTO, System.TOOLBAR_BTN_CLASSES.REPORTS, System.TOOLBAR_BTN_CLASSES.ADD, System.TOOLBAR_BTN_CLASSES.EXPORT];

      _.each(buttons, function (button) {
        _.each(_this10.itemsButtonsData, function (item) {
          var cls = item.options.elementAttr && item.options.elementAttr['class'];

          if (cls && cls.trim() === button) {
            _this10._isReadOnly && readOnlyButtons.includes(button) ? item.options.disabled = true : item.options.disabled = disabled;
          }
        });

        _.each(_this10._dataContextMenu, function (item) {
          var cls = item.elementAttr && item.elementAttr['class'];

          if (cls && cls.trim() === button) {
            item.disabled = disabled;
          }
        });
      });

      this._toolbarInstance.dxToolbar({
        items: this.itemsButtonsData
      });
    }
  }, {
    key: "toggleClasses",
    value: function toggleClasses(_ref2) {
      var _this11 = this;

      var buttons = _ref2.buttons,
          attr = _ref2.attr;

      _.each(buttons, function (button) {
        _.each(_this11.itemsButtonsData, function (item) {
          var cls = item.options.elementAttr && item.options.elementAttr['class'];

          if (cls && cls.trim() === button) {
            attr ? item.options.elementAttr['data-enable'] = attr : delete item.options.elementAttr['data-enable'];
          }
        });
      });

      this._toolbarInstance.dxToolbar({
        items: this.itemsButtonsData
      });
    }
  }, {
    key: "setDefaultStateButtons",
    value: function setDefaultStateButtons() {
      var _System$TOOLBAR_BTN_C = System.TOOLBAR_BTN_CLASSES,
          EDIT = _System$TOOLBAR_BTN_C.EDIT,
          MULTI_EDIT = _System$TOOLBAR_BTN_C.MULTI_EDIT,
          DEL = _System$TOOLBAR_BTN_C.DEL,
          DESELECT = _System$TOOLBAR_BTN_C.DESELECT,
          GOTO = _System$TOOLBAR_BTN_C.GOTO,
          REPORTS = _System$TOOLBAR_BTN_C.REPORTS;
      this.disableButtons({
        buttons: [EDIT, MULTI_EDIT, DEL, DESELECT, GOTO, REPORTS],
        disabled: true
      });
    }
  }, {
    key: "setReadOnlyMode",
    value: function setReadOnlyMode(_ref3) {
      var mode = _ref3.mode;
      var _System$TOOLBAR_BTN_C2 = System.TOOLBAR_BTN_CLASSES,
          DEL = _System$TOOLBAR_BTN_C2.DEL,
          SELECT = _System$TOOLBAR_BTN_C2.SELECT,
          DESELECT = _System$TOOLBAR_BTN_C2.DESELECT,
          GOTO = _System$TOOLBAR_BTN_C2.GOTO,
          REPORTS = _System$TOOLBAR_BTN_C2.REPORTS,
          ADD = _System$TOOLBAR_BTN_C2.ADD,
          EXPORT = _System$TOOLBAR_BTN_C2.EXPORT;
      this._isReadOnly = mode;
      this.disableButtons({
        buttons: [DEL, SELECT, DESELECT, GOTO, REPORTS, ADD, EXPORT],
        disabled: true
      });
    }
  }, {
    key: "callTableKeyboardEvents",
    value: function callTableKeyboardEvents(event) {
      var _this12 = this;

      var buttonData;
      var editableControls = ['INPUT', 'SELECT', 'TEXTAREA'];
      if (!event || editableControls.includes(event.target.tagName) && event.keyCode === 46) return;
      event['component'] = {
        'NAME': System.DX_CONTROLS.dxButton
      };

      switch (event.keyCode) {
        case 45:
          //Insert
          buttonData = _.find(this._toolbarItemsData, function (obj) {
            return obj.options.ButtonType === System.BUTTON_TYPE.ADD;
          });
          break;

        case 13:
          //Enter
          buttonData = _.find(this._toolbarItemsData, function (obj) {
            return obj.options.ButtonType === System.BUTTON_TYPE.EDIT;
          });
          break;

        case 46:
          //Delete
          buttonData = _.find(this._toolbarItemsData, function (obj) {
            return obj.options.ButtonType === System.BUTTON_TYPE.DELETE;
          });
          break;

        case 116:
          //Alt+F5
          if (event.altKey) buttonData = _.find(this._toolbarItemsData, function (obj) {
            return obj.options.ButtonType === System.BUTTON_TYPE.REFRESH;
          });
          break;
      }

      if (buttonData && !buttonData.options.disabled) {
        switch (buttonData.options[Fields.ButtonType]) {
          case System.BUTTON_TYPE.ADD:
            this.editButtonEvent(buttonData.options, event);
            break;

          case System.BUTTON_TYPE.EDIT:
            this.editButtonEvent(buttonData.options, event);
            break;

          case System.BUTTON_TYPE.DELETE:
            setTimeout(function () {
              return tbDeleteRowsClicked({
                event: event,
                formUUID: _this12._UUID
              });
            });
            break;

          case System.BUTTON_TYPE.REFRESH:
            setTimeout(function () {
              return d5TableRefresh(_this12._UUID);
            });
            break;
        }
      }
    }
  }, {
    key: "updateButtonsUUID",
    value: function updateButtonsUUID() {
      var _this13 = this;

      _.each(this._buttonsForUpdateData, function (item) {
        if (typeof item.updateUUID === 'function') item.updateUUID(_this13._UUID);
      });
    }
  }, {
    key: "destructor",
    value: function destructor() {//_store = Map(defStore).toObject()
    }
  }]);

  return TableToolBarStoreClass;
}(StoreClass);

export { TableToolBarStoreClass as default };